import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  uploadYourOrders: {
    description: 'Header text for the FTU CSV upload section',
    defaultMessage: 'Upload your orders',
    id: 'LWAzQt',
  },
  startByDownloading: {
    description: 'Text for the first checklist item about downloading sample CSV',
    defaultMessage: 'Start by',
    id: 'WY40R2',
  },
  downloadSampleCsv: {
    description: 'Link text to download sample CSV file',
    defaultMessage: 'Downloading our sample CSV file',
    id: 'ytSWps',
  },
  chooseStoreForImport: {
    description: 'Text for the second checklist item about choosing a store',
    defaultMessage: 'Choose a store for import',
    id: 'pL+MRG',
  },
  dragDropPrompt: {
    description: 'Main drag and drop prompt text',
    defaultMessage: 'Drag and drop a {types} file here',
    id: '/Y82yd',
  },
  or: {
    description: 'Single word "or" between drag-drop and select button',
    defaultMessage: 'or',
    id: 'uX+Flw',
  },
  selectAFile: {
    description: 'Button text inside drag-drop area to select a file',
    defaultMessage: 'Select a file',
    id: 'aMLpls',
  },
  selectFile: {
    description: 'Button text to process the uploaded CSV file',
    defaultMessage: 'Select a file',
    id: 'jyHP6N',
  },
  replaceFile: {
    description: 'Button text to replace the uploaded file',
    defaultMessage: 'Replace file',
    id: 'UgpquO',
  },
  fileTooBig: {
    description: 'Error message when file size exceeds maximum',
    defaultMessage: 'File size is too big. Select a file smaller than {filesize}MB.',
    id: 'P2oXKd',
  },
  fileZeroSize: {
    description: 'Error message when file has no content',
    defaultMessage: 'File with no content.',
    id: 'kuYx8D',
  },
  fileTypeError: {
    description: 'Error message when file type is not supported',
    defaultMessage: 'File type is not supported. Select {types} file.',
    id: 'Fjq8IP',
  },
  processing: {
    description: 'Text shown when CSV file is being processed',
    defaultMessage: 'Processing',
    id: 'h90wO2',
  },
  processingDetails: {
    description: 'Details about processing progress',
    defaultMessage: '{processed} of {total} processed',
    id: 'rePxH0',
  },
  checkingProgress: {
    description: 'Text shown when checking import progress',
    defaultMessage: 'Checking progress...',
    id: 'sxsFSh',
  },
  importComplete: {
    description: 'Text shown when import is complete',
    defaultMessage: 'Import Complete',
    id: 'kySvjB',
  },
  importCompleteDetails: {
    description: 'Details about completed import',
    defaultMessage: '{processed} orders imported successfully',
    id: 'Qrip0e',
  },
  importFailed: {
    description: 'Text shown when import fails',
    defaultMessage: 'Import Failed',
    id: 'GL00GH',
  },
  importFailedDetails: {
    description: 'Details about failed import',
    defaultMessage: 'There was an error processing your file. Please try again.',
    id: '4F7FTi',
  },
});
